import {DataService} from "@/service/data";

const state = {};

const getters = {};

const actions = {
    getCurrentSubscription() {
        return DataService.getCurrentSubscription();
    },

    async getCurrentResidentialSubscription() {
        try {
            const response = await DataService.getCurrentResidentialSubscription();
            return response.data;
        } catch (error) {
            return {};
        }
    },

    async getCurrentDatacenterSubscription() {
        try {
            const response = await DataService.getCurrentDatacenterSubscription();
            return response.data;
        } catch (error) {
            return {};
        }
    },

    getPlans() {
        return DataService.getPlans();
    },

    getResidentialPlans() {
        return DataService.getResidentialPlans();
    },

    getDatacenterPlans() {
        return DataService.getDatacenterPlans();
    }
};

const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
